/** Response envelope containing the public VAPID key used for browser push subscription. */
export class VapidPublicKeyResponse {
  public_key?: string
}

/** A single registered push subscription endpoint. */
export class PushSubscriptionResponse {
  endpoint?: string
}

/** List response for the authenticated user's registered push subscriptions. */
export class PushSubscriptionListResponse {
  items?: PushSubscriptionResponse[]
}